import { IEventoGenerico } from 'modelos/src';
import {
  IEstadoCelda,
  TonoEstado,
} from '../../../../auxiliares/tabla/tabla.interfaces';

/**
 * Estado de una solicitud de servicio técnico para la pieza `estado` de la
 * tabla: el nombre real del dato, con el tono y el ícono de docs/ICONOS.md.
 */
const ESTADOS: Record<string, [TonoEstado, string]> = {
  // Técnicos
  Pendiente: ['aviso', 'pending'],
  Asignado: ['info', 'engineering'],
  'En Atención': ['info', 'pending'],
  'Pendiente de Aprobación': ['aviso', 'pending'],
  'Firma Cliente': ['info', 'pending'],
  Finalizado: ['ok', 'task_alt'],
  // Eventos (por si llega una variante no técnica)
  'Sin Tratamiento': ['aviso', 'warning'],
  'En Espera': ['info', 'pending'],
  Liberada: ['info', 'pending'],
  Finalizada: ['ok', 'task_alt'],
};

export function estadoTecnicoCelda(
  evento: Pick<IEventoGenerico, 'estado'>,
): IEstadoCelda | undefined {
  const estado = evento.estado as string | undefined;
  if (!estado) return undefined;
  const [tono, icono] = ESTADOS[estado] ?? ['neutro', undefined];
  return { texto: estado, tono, icono };
}
